<template>
  <div v-if="broker != null">

    <div class="text-lg">Client Sources</div>
    
    <div class="my-8">
      <template v-if="data != null">
        <template v-if="data.length == 0">
          <div class="text-sm">
            You have not added any client sources.
          </div>
        </template>

        <template v-else>
          <table class="bp-table mt-4">
            <thead>
              <tr class="border-b border-t border-gray-400">
                <th class="py-4 px-6 text-left border-r">
                  <div class="flex items-center justify-between">
                    Name
                  </div>
                </th>

                <th class="p-4 text-left border-r">
                  <div class="flex items-center justify-between">
                    Email
                  </div>
                </th>

                <th class="p-4 text-left border-r">
                  <div class="flex items-center justify-between">
                    Mobile
                  </div>
                </th>

                <th class="p-4 text-center border-r">
                  Type
                </th>

                <!-- <th class="p-4 text-center">
                  Actions
                </th> -->
              </tr>
            </thead>
            <tbody>
              <template v-for="(cs, index) in data">
                <tr :class="'border-b border-gray-300 ' + (index % 2 == 0 ? 'bg-gray-100' : 'bg-white')" @click="showCSModal(cs)">
                  <td class="p-4">{{ cs.first_name }} {{ cs.last_name }}</td>
                  <td class="p-4">{{ cs.email }}</td>
                  <td class="p-4">{{ cs.mobile }}</td>
                  <td class="p-4">{{ cs.source_type }}</td>
                </tr>
              </template>
            </tbody>
          </table>
        </template>
      </template>
    </div>

    <CSModal />
  </div>
</template>

<script>
  import { EventBus }   from '@/shared/event-bus'
  import SubmitButton2  from '@/shared/components/form/SubmitButton2'
  import CSModal        from './CSModal'
  
  export default {

    components: {
      SubmitButton2,
      CSModal
    },

    data () {
      return {
        loading: false,
        broker : null,
        data   : null,
      }
    },

    created() {
      this.broker = _.cloneDeep(this.$store.state[this.$store.state.view + 'Module'].broker)
      this.getData()
    },

    mounted() {
      EventBus.$on('get-data', () => {
        this.getData()
      })
    },

    methods : {
      getData() {
        this.apiGet({
          brokerId : this.broker.id        
        }, 'client-source/data', (data) => {
          this.data = data
        })
      },

      showCSModal(cs) {
        this.$modal.show('cs-modal', {
          clientSource : cs
        })
      },

      submit() {
        this.loading = true
        this.apiPost({
          settings       : this.settings,
          reportFrequency: this.reportFrequency
        }, 'broker/notification-settings', () => {
          this.loading = false
          EventBus.$emit('notification-event', {
            'type'   : 'success', 
            'message': 'Saved successfully.'
          }) 
        })
      }
    },
  }
</script>